import { BackOfficeLogo } from '@library/components/logos/BackOfficeLogo';
import { LinkGroup } from '@bo-components/navigation/LinkGroup';
import { NavUser } from '@bo-components/navigation/NavUser';
import { PROD } from '@bo-utils/environmentVariables';
import { StatusIndicator } from '@library/components/StatusIndicator';
import { getRoleActiveRoutes } from '@bo-utils/routes';
import { selectUserRoles } from '@bo-services/authenticationSlice';
import { useSelector } from 'react-redux';
import { useSplitFlag } from '@bo-hooks/useSplitFlag';

export const Navigation = () => {
  const userRoles = useSelector(selectUserRoles);

  const { treatment: availableRoutes } = useSplitFlag({
    flagName: 'BACKOFFICE-active-modules'
  });

  const sections = availableRoutes
    ? getRoleActiveRoutes({
        availableRoutes,
        userRoles
      }).map((grouping) => {
        const { groupName, routes } = grouping;

        return (
          <LinkGroup key={groupName} groupName={groupName} routes={routes} />
        );
      })
    : [];

  return (
    <nav
      className="text-soClean-120 flex h-screen flex-col items-start justify-between gap-y-6 p-4 py-6"
      title="App Navigation"
      data-testid="navigation"
    >
      <div className="flex items-center">
        <BackOfficeLogo />
        {PROD && (
          <>
            <StatusIndicator className="ml-3" status="prod" />
            <span className="text-status-failure pl-2 text-xs font-bold">
              PROD
            </span>
          </>
        )}
      </div>
      <div className="no-scrollbar h-[calc(100vh-210px)] w-full overflow-y-auto">
        {sections}
      </div>

      <NavUser />
    </nav>
  );
};
